/**
 * Inverts a dictionary from key-to-value to value-to-key. Works only for the dictionaries which values may be keys.
 * @param {object} dictionary Dictionary to revert.
 * @param {Function} mapFn Function to map inverted value to one that needed.
 * @returns {object}
 */
export function invertDictionary(dictionary, mapFn = undefined) {
  return Object.entries(dictionary).reduce((acc, [key, value]) => ({
    ...acc,
    [value]: mapFn ? mapFn(key) : key,
  }), {});
}
